import { render, staticRenderFns } from "./SubscriptionFlow.vue?vue&type=template&id=80d5e310&scoped=true&"
import script from "./SubscriptionFlow.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFlow.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFlow.vue?vue&type=style&index=0&id=80d5e310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d5e310",
  null
  
)

export default component.exports